import React, { useState } from 'react'
import { Col, Container, Image, Row } from 'react-bootstrap'
import QueryForm from '../../../Pages/Static/queryForm'
// import watchRepaire from '../../../Assets/images/alicias-img/watch-repaire.png'
import BellRossBanner from '../../../../Assets/images/alicias-img/bell-and-ross.png'
import BellRossBannerMobile from '../../../../Assets/images/alicias-img/bell-and-ross-mobile.png'
import { isMobileOnly } from 'react-device-detect'

const BellAndRoss = () => {
  const [showtext, setShowtext] = useState(false);
  return (
    <>
      <div className='watch_repaire_services_page'>
      <Container fluid>
            <Row>
                <Col sm={12} md={12} lg={12} className="p-0">
                <div>
                {isMobileOnly ? <Image src={BellRossBannerMobile} className='img-fluid'  alt='Oris'/>: <Image src={BellRossBanner} className='img-fluid'  alt='Oris'/>}
                </div>
                </Col>
            </Row>
      </Container>
      <Container>
          <div className='text-center pt-5'>
            <Row className='justify-content-center'>
              <Col lg={8}>
                <h3 className='text-center text-uppercase'>
                Bell & Ross
                </h3>
                <p>
                Step up your style with Bell & Ross – where precision and elegance meet in perfect harmony. Inspired by aviation, each timepiece merges advanced technology with sleek, modern design, crafted for those who live boldly. This is more than a watch – it's a symbol of confidence and adventure, made to push boundaries and redefine your daily routine. From the precision of the cockpit to the demands of your lifestyle, Bell & Ross elevates how you experience time. Embrace every moment with a watch that’s as daring and dynamic as you are. Bell & Ross – where time transforms your life.


                </p>
              </Col>
            </Row>
          </div>
        </Container>
      <QueryForm/>

      {/* <div className='text-center ulEnable mb-5 pb-4'>
          <Container>
            <h2 className='mb-4'>
            BELL & ROSS WATCHES
            </h2>

           
            <p>
            Bell & Ross is a French luxury watch brand renowned for its commitment to legibility, functionality, reliability, and precision. Since its establishment in 1992, the brand has crafted exceptional aviation timepieces distinguished by their distinctive square cases, making them instantly recognizable and highly admired.
            </p>

            <h4>
            BELL & ROSS HISTORY
            </h4>
            <p>
            Founded by Carlos Rosillo (Ross) and Bruno Belamich (Bell) in 1992 in France, Bell & Ross set out to create durable and accurate timepieces tailored for professionals, particularly inspired by aviation. Over the years, the brand expanded its offerings to include watches for military and high-speed motorsports applications. Notable achievements include the Space 1 model, the first automatic chronometer worn in space, and the Hydro Challenger, setting a Guinness World Record with its 11,000-meter water resistance. Today, Bell & Ross is headquartered in Paris with manufacturing facilities in La Chaux-de-Fonds, Switzerland, continuing to uphold its commitment to functional innovation and reliability.
            </p>
            <h4>
            BELL & ROSS COLLECTIONS
            </h4>
         <p>
         Bell & Ross presents a diverse array of collections, each characterized by its unique design and purpose:
         </p>
         <h4>
         BELL & ROSS BR 03 COLLECTION
         </h4>
         <p>
         The BR 03 collection epitomizes the classic Bell & Ross aesthetic with its utilitarian design and exceptional readability. Featuring a 42mm square case, robust construction, and 100m water resistance, these watches serve as an introduction to the world of Bell & Ross.
         </p>
         <h4>
         BELL & ROSS BR 05 COLLECTION
         </h4>
         <p>
         Inspired by Gerald Genta's designs, the BR 05 collection represents Bell & Ross's foray into steel-integrated sports watches. With brushed bezels and rounded hands, these timepieces maintain the brand's iconic square case and dial layout.
         </p>
         <h4>
         BELL & ROSS BR-X5 COLLECTION
         </h4>
         <p>
         Building upon the BR 05 line, the BR-X5 collection enhances craftsmanship with superior finishing and upgraded movements from Kenissi's manufacture. Utilizing materials like carbon, these watches blend sportiness with casual elegance, appealing to modern watch enthusiasts.
         </p>
         <h4>
         BELL & ROSS VINTAGE COLLECTION
         </h4>
         <p>
         The Vintage collection introduces round cases infused with aviation-inspired designs and contemporary elements. Ideal for daily wear, these watches combine retro aesthetics with modern functionality, featuring models such as the BR V2-92 and BR V3-94.
         </p>
         <h4>
         BELL & ROSS BR-X1 COLLECTION
         </h4>
         <p>
         The BR-X1 collection exemplifies Bell & Ross's fusion of concept and haute horology, showcasing skeleton dials, titanium cases, and meticulous craftsmanship. Designed for enthusiasts seeking adventure, these watches offer impressive water resistance and a bold presence.
         </p>
         <h4>
         BELL & ROSS BR S EDITIONS
         </h4>
         <p>
         Bell & Ross's BR S editions offer budget-friendly options with smaller 39mm cases and quartz movements in many models. Designed for both men and women, these watches prioritize wearability and versatility while embodying the brand's distinctive style.
         </p>
         <h4>
         BELL & ROSS BR 01 COLLECTION
         </h4>
         <p>
         The BR 01 collection is an iconic line known for its large 46mm square case designed for pilots. Emphasizing legibility and functionality, these watches remain a cornerstone of Bell & Ross's identity and heritage.
         </p>
         <p>
         Bell & Ross continues to innovate within the luxury watch industry, combining technological expertise with unique design elements to produce timepieces that are both functional tools and bold fashion statements.
         </p>
         <h4>
         BELL & ROSS WATCHES
         </h4>
         <p>
         Since its founding in 1992, Bell & Ross has established itself as a premier French luxury watch brand known for its precision, functionality, and distinctive square-shaped designs inspired by aviation.
         </p>
         <h4>
         BEST SELLING BELL & ROSS WATCHES
         </h4>
         <p>
         Discover some of the top-selling Bell & Ross timepieces available at Alicia's Jewelers
         </p>
         <h4>
         BELL & ROSS BR 05 GMT ON STRAP (REF. BR05G-BL-ST/SRB)
         </h4>
         <p>
         The BR 05 GMT blends modern aesthetics with functionality. It features a 41mm square case, options for an integrated steel bracelet or rubber strap, and 100m water resistance. The GMT hand and date window add practicality.
         </p>
         <h4>
         BELL & ROSS BR-X5 BLACK ON BRACELET (REF. BRX5R-BL-ST/SST)
         </h4>
         <p>
         The BR-X5 showcases Bell & Ross's high-end sports watch prowess, housing the BR-CAL.323 caliber with a 70-hour power reserve. Crafted from multiple components, its steel bracelet emphasizes robust design and luxury.
         </p>
         <h4>
         BELL & ROSS BR 03-94 MULTIMETER (REF. BR0394-SW-CE/SRB)
         </h4>
         <p>
         Limited to 500 pieces, the BR 03-94 Multimeter is a ceramic-encased chronograph integrating multiple time and speed measurement indicators. It appeals to collectors with its complex dial design.
         </p>
         <h4>
         BELL & ROSS V2-92 ORANGE LIMITED EDITION ON STRAP (REF. BRV292-O-ST/SRB)
         </h4>
         <p>
         With only 500 pieces made, the V2-92 Orange features a vibrant orange dial in a 41mm round case. Offering 100m water resistance, it suits aviation enthusiasts seeking bold design and reliability.
         </p>
         <h4>
         BELL & ROSS MOVEMENTS
         </h4>
         <p>
         Bell & Ross utilizes various movements—automatic, manual, and quartz—including ETA, Sellita, in-house, and Kenissi movements. This range caters to different price points and performance needs across their collections.
         </p>
         <h4>
         BELL & ROSS WATCH COLORS
         </h4>
         <p>
         From classic black, silver, and blue to vibrant orange, green, and red, Bell & Ross offers a diverse palette of dial colors. This adds flair and diversity to their aviation and sports-inspired timepieces.
         </p>
         <h4>
         BELL & ROSS WATCH MATERIALS
         </h4>
         <p>
         Bell & Ross employs stainless steel, titanium, bronze, ceramic, and carbon in their watch cases, ensuring a wide range of options from robust sports watches to innovative luxury designs.
         </p>
         <h4>
         BELL & ROSS WATCH TYPES
         </h4>
         <p>
         Specializing in aviation and sports watches like the BR 01, BR 03, BR 05, and Vintage lines, Bell & Ross also offers dressier options in the Vintage and BR S collections, appealing to a broad spectrum of tastes.
         </p>
         <h4>
         BELL & ROSS WATCH COMPLICATIONS
         </h4>
         <p>
         While focusing on straightforward three-hand designs with date indicators, Bell & Ross also offers complications like GMT, chronographs, and tourbillons in select models, enhancing functionality across their collections.
         </p>
         <h4>
         BELL & ROSS PARTNERSHIPS & BRAND AMBASSADORS
         </h4>
         <p>
         Collaborating with entities like Patrouille de France and the Tara Ocean Foundation, Bell & Ross creates special edition watches that reflect their commitment to aviation heritage and environmental conservation.
         </p>
        <h4>
        CARING FOR YOUR BELL & ROSS WATCH
        </h4>
        <p>
        Proper care and maintenance are essential for preserving the longevity and performance of your Bell & Ross watch. Alicia's Jewelers provides comprehensive servicing and repairs to ensure your luxury timepiece remains in optimal condition.
        </p>
         <h4>
         BELL & ROSS FAQ
         </h4>
         <p>
         Explore common questions about Bell & Ross watches, including their luxury status, value proposition, special features, and popular collections.
         </p>
         <h4>
         FIND YOUR NEW BELL & ROSS WATCH WITH ALICIA'S JEWELERS
         </h4>
         <p>
         Alicia's Jewelers is your trusted source for authentic Bell & Ross watches, offering both online and in-store shopping experiences. Benefit from expert guidance, free shipping on orders above $1,000, and comprehensive warranty support for your luxury timepiece.
         </p>
     
          </Container>
        </div> */}

<Container className="rcs_shap-wizard_container mb-5">
          <div className="watchsContent">
            <div style={showtext ? { height: '100%' } : { height: '200px', overflow: 'hidden' }} className="watchsContentData">
              

              <h2>Bell &amp; Ross</h2>
              <p ><strong>Exploring Bell &amp; Ross: A Legacy of Precision and Innovation</strong></p>
              <p >Bell &amp; Ross, a French watch company founded in 1992 by Carlos Rosillo (Ross) and Bruno Belamich (Bell), aimed to provide professionals with functional and dependable timepieces. This vision positioned Bell &amp; Ross as a leader in aviation watches, initially collaborating with Sinn for their models.</p>
              <p >In over three decades since its founding, Bell &amp; Ross has expanded its repertoire to include timepieces tailored for military use and high-speed motorsports, marking significant growth from its inception.</p>
              <p >Key milestones in Bell &amp; Ross&apos;s history include the Space 1 model, the first automatic chronometer worn in space, and the iconic Bomb Disposal Type, renowned for its anti-magnetic case and unparalleled precision. Bell &amp; Ross also secured a place in the Guinness Book of World Records with the Hydro Challenger, a watch boasting an impressive water resistance of 11,000 meters.</p>
              <p >Headquartered in Paris with manufacturing facilities in La Chaux-de-Fonds, Switzerland, Bell &amp; Ross maintains its commitment to functionality and reliability, delivering watches that meet the highest standards of craftsmanship.</p>
              <p >Explore the precision and innovation of Bell &amp; Ross watches at Alicia&apos;s Jewelers today!
                <br /><br /><strong>Discover the Bell &amp; Ross BR-X5 Collection at Alicia&apos;s Jewelers<br /></strong></p>
              <p >The BR-X5 collection represents an evolution of the BR 05 line, offering enhanced standards with superior finishing and an upgraded movement from Kenissi&apos;s manufacture. Bell &amp; Ross has also intensified its focus on utilizing exotic materials, including a carbon case, and expertly sculpting the case design. This blend results in an exceptional sports-casual timepiece, perfect for the discerning enthusiast.</p>
              <p ><strong>Bell &amp; Ross 03 Collection</strong><br />The Bell &amp; Ross BR 03 collection epitomizes the brand&apos;s commitment to functional design and exceptional legibility. Featuring a practical 42mm case size, robust construction, and 100m water resistance, this collection provides an ideal introduction to the world of Bell &amp; Ross. Available at Alicia&apos;s Jewelers, these timepieces offer a perfect blend of style and utility.</p>
              <p ><strong>Bell &amp; Ross BR 01 Collection&nbsp;</strong></p>
              <p >The BR 01 is Bell &amp; Ross&apos; longest-standing watch collection still featured in their current catalog. Despite its substantial 46mm case size, the BR 01 was designed for pilots to wear over their flight suit cuffs, ensuring optimal legibility and ease of handling. This timepiece exemplifies functionality while showcasing the brand&apos;s iconic style. Explore the BR 01 collection at Alicia&apos;s Jewelers.</p>
              <p ><strong>Bell &amp; Ross BR 05 Collection&nbsp;</strong><br />&nbsp;<br />&nbsp;The BR 05 marks Bell &amp; Ross&apos;s entry into the world of steel-integrated sports watches. Drawing inspiration from Gerald Genta&apos;s designs, these timepieces feature a variety of finishing techniques, including a brushed bezel and a rounded handset. However, the rounded square edges of the watch case and the dial layout maintain Bell &amp; Ross&apos;s signature design language. Discover the BR 05 collection at Alicia&apos;s Jewelers.<br />&nbsp;<br /><strong><span >Bell &amp; Ross BR-X1 Collection&nbsp;</span></strong></p>
              <p ><span >The BR-X1 collection epitomizes a unique blend of innovation and haute horology within the Bell &amp; Ross brand. Featuring skeleton dials, intricately finished movement bridges, titanium cases, meticulous case finishing, and impressive water resistance, this collection is designed for adventurers and thrill-seekers. Wearing a BR-X1 is akin to having a Formula 1 car on your wrist. Explore the BR-X1 collection at Alicia&apos;s Jewelers.</span></p>
              <p ><strong><span >Bell &amp; Ross Vintage Collection&nbsp;</span></strong></p>
              <p ><span >The Bell &amp; Ross Vintage collection offers a sophisticated and understated elegance with its round cases. These timepieces maintain their aviation heritage while introducing modern elements such as updated case sizes, a variety of dial colors, and enhanced functionalities, making them ideal for everyday wear. The collection features models like the BR V2-92, BR V2-93, BR V3-94, and more. Explore the refined charm of the Vintage collection at Alicia&apos;s Jewelers.</span></p>
              <p ><strong><span >Bell &amp; Ross BR S Editions&nbsp;</span></strong></p>
              <p ><span >The Bell &amp; Ross BR S Editions offer an accessible entry point into the brand&rsquo;s world, featuring quartz movements that keep the collection budget-friendly. With their compact 39mm cases, these square timepieces provide a more wearable option compared to larger round watches. Additionally, some BR S models are thoughtfully designed with slimmer profiles and dial layouts, catering specifically to female wearers. Discover the versatile and stylish BR S Editions at Alicia&apos;s Jewelers.</span></p>
              <p ><strong><span >Bell &amp; Ross Collections&nbsp;</span></strong></p>
              <p ><span >Bell &amp; Ross offers a diverse range of timepieces, with a notable focus on their signature square case designs. Additionally, they present several round-shaped models. Below, we provide an overview and summary of the various Bell &amp; Ross collections available at Alicia&apos;s Jewelers.</span></p>
              <h3 ><strong><span >Bell &amp; Ross Watches: Pricing and Highlights</span></strong></h3>
              <p ><span >Bell &amp; Ross is a distinguished luxury watch brand renowned for its innovative designs and exceptional craftsmanship. With prices ranging from $2,000 to $20,000, Bell &amp; Ross offers a variety of models to suit different tastes and preferences. Here are some popular watches currently available:</span></p>
              <div className="table-responsive">
                <table >
                  <tbody>
                    <tr>
                      <td >
                        <p ><strong><span >Model</span></strong></p>
                      </td>
                      <td >
                        <p ><strong><span >Starting Price</span></strong></p>
                      </td>
                      <td >
                        <p ><strong><span >Unique Features</span></strong></p>
                      </td>
                    </tr>
                    <tr>
                      <td >
                        <p ><strong><span >Bell &amp; Ross BR 03 Black Steel</span></strong></p>
                      </td>
                      <td >
                        <p ><span >$3,600</span></p>
                      </td>
                      <td >
                        <p ><span >Square case design and legible dial</span></p>
                      </td>
                    </tr>
                    <tr>
                      <td >
                        <p ><strong><span >Bell &amp; Ross BR 03-92 Diver Blue</span></strong></p>
                      </td>
                      <td >
                        <p ><span >$3,400</span></p>
                      </td>
                      <td >
                        <p ><span >Unique square satin case with a sporty yet attractive design</span></p>
                      </td>
                    </tr>
                    <tr>
                      <td >
                        <p ><strong><span >Bell &amp; Ross BR-X5 Ice Blue</span></strong></p>
                      </td>
                      <td >
                        <p ><span >$6,900</span></p>
                      </td>
                      <td >
                        <p ><span >Gorgeous Ice Blue dial color and integrated bracelet</span></p>
                      </td>
                    </tr>
                    <tr>
                      <td >
                        <p ><strong><span >Bell &amp; Ross BR-X5 Carbon Orange</span></strong></p>
                      </td>
                      <td >
                        <p ><span >$11,800</span></p>
                      </td>
                      <td >
                        <p ><span >Carbon fiber case with contrasting orange rubber strap</span></p>
                      </td>
                    </tr>
                    <tr>
                      <td >
                        <p ><strong><span >Bell &amp; Ross BR 05 GMT Sky Blue</span></strong></p>
                      </td>
                      <td >
                        <p ><span >$5,500</span></p>
                      </td>
                      <td >
                        <p ><span >BR-CAL.325 with GMT complication and integrated bracelet</span></p>
                      </td>
                    </tr>
                    <tr>
                      <td >
                        <p ><strong><span >Bell &amp; Ross V2-92 Orange Limited</span></strong></p>
                      </td>
                      <td >
                        <p ><span >$3,500</span></p>
                      </td>
                      <td >
                        <p ><span >Bright orange dial color and military design</span></p>
                      </td>
                    </tr>
                    <tr>
                      <td >
                        <p ><strong><span >Bell &amp; Ross BR-X1 Hyperstellar</span></strong></p>
                      </td>
                      <td >
                        <p ><span >$19,900</span></p>
                      </td>
                      <td >
                        <p ><span >Skeleton dial and avant-garde design</span></p>
                      </td>
                    </tr>
                    <tr>
                      <td >
                        <p ><strong><span >Bell &amp; Ross BRS-BLC-ST</span></strong></p>
                      </td>
                      <td >
                        <p ><span >$2,200</span></p>
                      </td>
                      <td >
                        <p ><span >Slim case design and quartz movement</span></p>
                      </td>
                    </tr>
                    <tr>
                      <td >
                        <p ><strong><span >Bell &amp; Ross BR V2-92 Aeronavale</span></strong></p>
                      </td>
                      <td >
                        <p ><span >$3,600</span></p>
                      </td>
                      <td >
                        <p ><span >Vintage-inspired dive watch design with gilt markers</span></p>
                      </td>
                    </tr>
                    <tr>
                      <td >
                        <p ><strong><span >Bell &amp; Ross BR-01 Cyber Skull Bronze</span></strong></p>
                      </td>
                      <td >
                        <p ><span >$11,400</span></p>
                      </td>
                      <td >
                        <p ><span >Skeleton skull dial and bronze case</span></p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <h4 ><strong><span >Notable Models:</span></strong></h4>
              <ul class="decimal_type" >
                <li><strong><span >Bell &amp; Ross BR 03 Black Steel<br />&nbsp;</span></strong><span >Priced at $3,600, this model features the iconic square case design and a highly legible dial, making it both stylish and functional.</span></li>
                <li><strong><span >Bell &amp; Ross BR 03-92 Diver Blue<br />&nbsp;</span></strong><span >Starting at $3,400, the Diver Blue showcases a unique square satin case and a sporty, attractive design, ideal for diving enthusiasts.</span></li>
                <li><strong><span >Bell &amp; Ross BR-X5 Ice Blue on Rubber Strap<br />&nbsp;</span></strong><span >At $6,900, this watch stands out with its stunning Ice Blue dial and integrated bracelet, offering a blend of elegance and sportiness.</span></li>
                <li><strong><span >Bell &amp; Ross BR-X5 Carbon Orange on Rubber Strap<br />&nbsp;</span></strong><span >This model, priced at $11,800, features a carbon fiber case paired with a striking orange rubber strap, embodying modernity and boldness.</span></li>
                <li><strong><span >Bell &amp; Ross BR 05 GMT Sky Blue<br />&nbsp;</span></strong><span >With a starting price of $5,500, the GMT Sky Blue features the BR-CAL.325 movement with a GMT complication and an integrated bracelet, perfect for frequent travelers.</span></li>
                <li><strong><span >Bell &amp; Ross V2-92 Orange Limited Edition on Strap<br />&nbsp;</span></strong><span >At $3,500, this limited edition watch boasts a bright orange dial and a military-inspired design, making it a unique and eye-catching piece.</span></li>
                <li><strong><span >Bell &amp; Ross BR-X1 Hyperstellar<br />&nbsp;</span></strong><span >Priced at $19,900, the Hyperstellar offers an avant-garde design with a skeleton dial, appealing to those who appreciate cutting-edge horology.</span></li>
                <li><strong><span >Bell &amp; Ross BRS-BLC-ST<br />&nbsp;</span></strong><span >This model, available for $2,200, features a slim case design and a reliable quartz movement, providing a sleek and modern look.</span></li>
                <li><strong><span >Bell &amp; Ross BR V2-92 Aeronavale<br />&nbsp;</span></strong><span >Starting at $3,600, the Aeronavale is a vintage-inspired dive watch with gilt markers, blending nostalgia with modern performance.</span></li>
                <li><strong><span >Bell &amp; Ross BR-01 Cyber Skull Bronze Rubber Strap<br />&nbsp;</span></strong><span >At $11,400, this watch is characterized by its skeleton skull dial and bronze case, offering a bold and distinctive appearance.</span></li>
              </ul>
              <p ><span >Experience the world of Bell &amp; Ross watches at Alicia&apos;s Jewelers, where luxury and innovation come together to create timeless masterpieces.</span></p>
              <p ><span >&nbsp;</span></p>
              <h3 ><strong><span >Discover Your New Bell &amp; Ross Watch with Alicia&apos;s Jewelers</span></strong></h3>
              <p ><span >When it comes to purchasing a new or pre-owned Bell &amp; Ross watch, selecting a reliable source is paramount. Alicia&apos;s Jewelers is committed to providing exceptional service and a wide selection of Bell &amp; Ross timepieces. Whether you are interested in the latest Bell &amp; Ross BR 03-A models or their innovative concept timepieces, our team of specialists is here to assist you in finding the perfect watch to meet your needs.</span></p>
              <p ><span >For those who prefer an in-person shopping experience, Alicia&apos;s Jewelers welcomes you to visit our boutique located in Naples, FL. We are open Monday to Saturday from 10 AM to 5 PM.</span></p>
              <p ><span >Alternatively, if you wish to shop online, we offer complimentary standard shipping on all orders over $1,000. Rest assured, we provide insurance for your luxury timepiece from the moment it leaves our facility until it safely arrives at your doorstep. Additionally, all our watches come with the full manufacturer warranty. Should any issues arise, please contact us, and we will facilitate the necessary repairs to ensure your complete satisfaction.</span></p>
            </div>
            <div className="blrbox"></div>
            <span className="readbtn" onClick={() => setShowtext(!showtext)}>{showtext ? 'Read Less' : 'Read More'}</span>
          </div>
        </Container>
      </div>
    </>
    
  )
}

export default BellAndRoss
